<!--
  Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
<br/>
<h1 class="page-header">Extraction Compare Tool</h1>
<br/>
@if (permission()) {
  <table class="files-input" [class.hidden]="!showFileInput">
    <tr>
      <td>
        <app-file-upload-card (filesSelected)="onFileSelected($event, 'file1')"
          [header]="'Excel file:'"
        [subheader]="'*Select 1st Excel file'"></app-file-upload-card>
      </td>
      <td>
        <app-file-upload-card (filesSelected)="onFileSelected($event, 'file2')"
          [header]="'Excel file:'"
        [subheader]="'*Select 2nd Excel file'"></app-file-upload-card>
      </td>
      <td>
        <app-file-upload-card (filesSelected)="onFileSelected($event, 'prolFile')"
          [header]="'PROL file:'"
        [subheader]="'Optional - Select PROL file'"></app-file-upload-card>

      </td>
    </tr>
    <tr>
      <td></td>
      <td></td>
      <td>
        <div class="buttons pull-right">
          <p-button label="Compare" icon="pi pi-check" class="gm-btn-primary mr-2"
            [disabled]="!(file1 && file2) || !permission()" (click)="runCompare()">
          </p-button>
        </div>
      </td>
    </tr>
  </table>
@if (progress() > 0) {
  <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
}
}


